import { useRef } from "react";


export default function SearchBar(props: {
    filter: (keyword: string) => void;
    removeSearchItem: () => void;
    keywordList?: string;
    type?: string;
}) {
    const {
        filter,
        removeSearchItem,
        keywordList,
        type,
    } = props;

    const inputRef = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        const keyword = inputRef.current?.value.trim() || "";
        filter(keyword);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleClick();
        }
    };

    const handleRemoveSearchItem = () => {
        if (inputRef.current) {
            inputRef.current.value = "";
        }
        removeSearchItem();
    };

    return (
        <>
            <div className="search">
                <div className="searchInputs">
                    <div className="advance-search">
                        <div className="advance-search-div">
                            <input
                                ref={inputRef}
                                id="menu-search-input"
                                className="search_input"
                                placeholder="Search..."
                                onKeyDown={handleKeyDown} />
                            <div className="search_icon" onClick={handleClick}>
                                {/* Search Icon */}
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clipPath="url(#clip0_522_381)">
                                        <path
                                            d="M10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18Z"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M15.8035 15.8035L21 21"
                                            stroke="#023E58"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_522_381">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {keywordList && (
                <ul className="search-items">
                    <li key={keywordList} className="search-item">
                        <div className="item-type">{type}:</div>
                        <div className="item-name">{keywordList}</div>
                        <div onClick={handleRemoveSearchItem} className="item-icon">
                            {/* Remove Icon */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <g clipPath="url(#clip0_522_401)">
                                    <path
                                        d="M12.4999 7.5L7.49988 12.5"
                                        stroke="#023E58"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.49988 7.5L12.4999 12.5"
                                        stroke="#023E58"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M9.99988 17.5C14.142 17.5 17.4999 14.1421 17.4999 10C17.4999 5.85786 14.142 2.5 9.99988 2.5C5.85774 2.5 2.49988 5.85786 2.49988 10C2.49988 14.1421 5.85774 17.5 9.99988 17.5Z"
                                        stroke="#023E58"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_522_401">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </li>
                </ul>
            )}
        </>
    );
};